import { useTranslation } from 'react-i18next';
import * as Styled from './ErrorMessage.styled';
import { capitalize } from '../../../utils/capitalize';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The single error message that displays in the Impact Block.
 *
 * The error message concatenates all errors together into a single string.
 *
 * This component, as configured, expects only a single possible error message to
 * exist for each errorable input.
 */
export const ErrorMessage = ({
  blockId,
  minDonationAmount,
  showErrorSpaceWhenNoVisibleErrors,
  showOtherAmountInputErrorMessage,
  showRecurringEndDateErrorMessage,
  showProgramDesignationErrorMessage,
  fitVertical
}) => {
  const {
    t
  } = useTranslation('blocks.impact');
  const errorMessages = [];
  if (showOtherAmountInputErrorMessage) {
    errorMessages.push(t('ErrorMessage.otherAmountInputError', {
      minDonationAmount,
      defaultValue: 'enter an amount greater than or equal to {{minDonationAmount}}'
    }));
  }
  if (showRecurringEndDateErrorMessage) {
    errorMessages.push(t('ErrorMessage.recurringEndDateError', 'enter a valid end date'));
  }
  if (showProgramDesignationErrorMessage) {
    errorMessages.push(t('ErrorMessage.programDesignationError', 'select a designation'));
  }
  let errorMessageString = '';
  if (errorMessages.length > 2) {
    errorMessageString = errorMessages
    // join all error messages except last with just a comma and space
    .slice(0, errorMessages.length - 1).join(', ')
    // join the last error message with ', and'
    .concat(`, and ${errorMessages.slice(-1)[0]}`);
  }
  if (errorMessages.length === 2) {
    errorMessageString = errorMessages.join(' and ');
  }
  if (errorMessages.length === 1) {
    // eslint-disable-next-line prefer-destructuring -- more readable this way imo
    errorMessageString = errorMessages[0];
  }
  const capitalizedErrorMessageString = capitalize(errorMessageString);
  const showErrorContainer = Boolean(errorMessageString || showErrorSpaceWhenNoVisibleErrors);
  return /*#__PURE__*/_jsx(Styled.ErrorContainer, {
    shouldShow: showErrorContainer,
    fitVertical: fitVertical,
    children: errorMessages.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Styled.ErrorIcon, {
        height: 16,
        width: 16
      }), /*#__PURE__*/_jsx(Styled.ErrorText, {
        id: `${blockId}-error-message`,
        role: "alert",
        children: capitalizedErrorMessageString
      })]
    })
  });
};